import template from './accessRulesTabComponent.html';

import './accessRulesTabComponent.css';

const accessRulesTabComponent = {
	bindings: {
		defaultSelectedRuleId: '<?', // int | undefined <- if the post has no rule assigned
		onAccessRuleChange: '&',
	},
	controller: AccessRulesTabComponentController,
	controllerAs: 'vm',
	template,
};

AccessRulesTabComponentController.$inject = ['Identity', 'AccessRulesService'];
function AccessRulesTabComponentController(Identity, AccessRulesService) {
	const vm = this;

	vm.noRuleOption = {
		id: 'none',
		name: '-- No Rule Applied --',
		description: 'No restrictions applied for this post',
		actions: [],
		groups: [],
		roles: [],
		hubs: [],
		isHidden: false,
	};

	this.$onInit = async () => {
		const hub = Identity.currentClient();
		const hubRules = await AccessRulesService.fetchHubRules({ accountId: hub.account_id, hubId: hub.id });

		vm.accessRulesManagementPageUrl = AccessRulesService.accessRulesManagementPageUrl;
		vm.rules = [vm.noRuleOption, ...hubRules];
		vm.selectedRule = this.defaultSelectedRuleId ? await fetchRule(this.defaultSelectedRuleId) : vm.noRuleOption;
		vm.selectedRuleId = vm.selectedRule.id;
	};

	vm.handleRuleChange = async ruleId => {
		vm.selectedRuleId = ruleId;

		if (ruleId === vm.noRuleOption.id) {
			vm.selectedRule = vm.noRuleOption;
			this.onAccessRuleChange({ rule: null });
		} else {
			vm.selectedRule = await fetchRule(ruleId);
			this.onAccessRuleChange({ rule: vm.selectedRule });
		}
	};

	async function fetchRule(ruleId) {
		if (ruleId) {
			const rule = await AccessRulesService.fetchRuleById(ruleId);

			rule.isHidden = rule.groups?.length === 0 || rule.roles?.length === 0;
			rule.hasRoleRestrictions = rule.roles !== null;

			return rule;
		} else {
			return vm.noRuleOption;
		}
	}
}

export default accessRulesTabComponent;
